// Shared SVG symbol sprite used by every ported screen.
// Lifted verbatim from the approved HTML files so <svg><use href="#X"/></svg>
// references continue to work.
import type { ReactNode } from 'react';

export function IconSprite(): ReactNode {
  return (
    <svg
      style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
      aria-hidden="true"
    >
      <defs>
        <symbol id="work" viewBox="0 0 24 24">
          <rect x="4" y="5" width="16" height="16" rx="3" />
          <path d="M9 5V3h6v2M8 11l2 2 5-5M8 17h8" />
        </symbol>
        <symbol id="chart" viewBox="0 0 24 24">
          <path d="M4 4v16h16M8 15v-4m5 4V7m5 8V5" />
        </symbol>
        <symbol id="people" viewBox="0 0 24 24">
          <circle cx="9" cy="8" r="3" />
          <path d="M3 20v-2a6 6 0 0 1 12 0v2M16 5a3 3 0 0 1 0 6m2 3a5 5 0 0 1 3 5" />
        </symbol>
        <symbol id="arrow" viewBox="0 0 24 24">
          <path d="M5 12h14m-5-5 5 5-5 5" />
        </symbol>
        <symbol id="message" viewBox="0 0 24 24">
          <path d="M5 4h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-6 3V6a2 2 0 0 1 2-2Z" />
          <path d="M7 9h10M7 13h6" />
        </symbol>
        <symbol id="refresh" viewBox="0 0 24 24">
          <path d="M20 8a8 8 0 0 0-14-3L3 8m0-5v5h5M4 16a8 8 0 0 0 14 3l3-3m0 5v-5h-5" />
        </symbol>
        <symbol id="check" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="9" />
          <path d="m8 12 3 3 5-6" />
        </symbol>
        <symbol id="box" viewBox="0 0 24 24">
          <path d="m3 7 9-4 9 4v11l-9 4-9-4V7Zm0 0 9 4 9-4M12 11v11M7 5l9 4" />
        </symbol>
        <symbol id="help" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="9" />
          <path d="M9 9a3 3 0 0 1 6 0c0 2-3 2-3 5m0 3h.01" />
        </symbol>
        <symbol id="lightning" viewBox="0 0 24 24">
          <path d="m13 2-9 12h7l-1 8 10-13h-7l1-7Z" />
        </symbol>
        <symbol id="clock" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 6v6l4 2" />
        </symbol>
        <symbol id="target" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="7" />
          <circle cx="12" cy="12" r="2" />
          <path d="M12 2v4m0 12v4M2 12h4m12 0h4" />
        </symbol>
        <symbol id="icon-send" viewBox="0 0 24 24">
          <path d="m22 2-7 20-4-9-9-4L22 2ZM11 13 22 2" />
        </symbol>
        <symbol id="horse" viewBox="0 0 24 24">
          <path d="m7 21 1-6-3-3 3-5 1-5 4 3 4 1 4 7-3 3-6-3-1 8M13 8h.01" />
        </symbol>
        <symbol id="search" viewBox="0 0 24 24">
          <circle cx="10.5" cy="10.5" r="6.5" />
          <path d="m16 16 5 5" />
        </symbol>
        <symbol id="bell" viewBox="0 0 24 24">
          <path d="M18 8a6 6 0 0 0-12 0c0 7-3 8-3 8h18s-3-1-3-8M10 21h4" />
        </symbol>
        <symbol id="chevron-down" viewBox="0 0 24 24">
          <path d="m6 9 6 6 6-6" />
        </symbol>
        <symbol id="mail" viewBox="0 0 24 24">
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="m3 6 9 7 9-7" />
        </symbol>
        <symbol id="pin" viewBox="0 0 24 24">
          <path d="M19 10c0 5-7 12-7 12S5 15 5 10a7 7 0 1 1 14 0Z" />
          <circle cx="12" cy="10" r="2" />
        </symbol>
      </defs>
    </svg>
  );
}

export function Icon({ id }: { id: string }): ReactNode {
  return (
    <svg>
      <use href={`#${id}`} />
    </svg>
  );
}
